export default "__VITE_ASSET__d7791c35__"